/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Typeplaceholder1Inputs */

const en_questionnaire_typeplaceholder1 = /** @type {(inputs: Questionnaire_Typeplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your answer here...`)
};

const fr_questionnaire_typeplaceholder1 = /** @type {(inputs: Questionnaire_Typeplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez votre réponse ici...`)
};

/**
* | output |
* | --- |
* | "Type your answer here..." |
*
* @param {Questionnaire_Typeplaceholder1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_typeplaceholder1 = /** @type {((inputs?: Questionnaire_Typeplaceholder1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Typeplaceholder1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_typeplaceholder1(inputs)
	return fr_questionnaire_typeplaceholder1(inputs)
});
export { questionnaire_typeplaceholder1 as "questionnaire_typePlaceholder" }